<template>
    <FormGroup
        type="select" :options="prefList" input-class="w-48"
        name="pref" label="都道府県" autocomplete="address-level1" required
        :value="value" @input="s => $emit('input', s)" :errors="errors"/>
</template>

<script>
import FormGroup from "./FormGroup";
import applicationSelectItem from "../../mixins/applicationSelectItem";

export default {
    name: "PrefPicker",
    components: {FormGroup},
    mixins: [applicationSelectItem],

    props: {
        value: {
            type: String
        },
        errors: {
            type: Object | Array,
            required: true
        }
    },
}
</script>

<style scoped>

</style>
